import { render, staticRenderFns } from "./Quotations.vue?vue&type=template&id=308b1291&"
import script from "./Quotations.vue?vue&type=script&lang=js&"
export * from "./Quotations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308b1291')) {
      api.createRecord('308b1291', component.options)
    } else {
      api.reload('308b1291', component.options)
    }
    module.hot.accept("./Quotations.vue?vue&type=template&id=308b1291&", function () {
      api.rerender('308b1291', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Leads/Tabs/Quotations.vue"
export default component.exports